/*eslint-disable*/

import React from 'react';
import './CommonModal.css';

/*
  handleClose = for closing overlay, 
  show = to show modal component,
  children = rendering children elemnts, 
  closeBtn = closing modal, 
  modalSuper = elements before heading, 
  modalTitle = title of element, 
  modalSubTitle = modal sub title, 
  backBtn = back to last modal, 
  modalCustomClass = custom class to modal, 
  handleBack = reset password back func,
  skipBtn = modal skip,
  subModalActive = extended modal,
  handleLinkAccount = actions from subModalActive
  subModalHtml = html for subModal
*/

export const Modal = ({
  handleClose,
  show,
  children,
  closeBtn,
  modalSuper,
  modalTitle,
  modalSubTitle,
  backBtn,
  modalCustomClass,
  handleBack,
  skipBtn,
  serverError,
  subModalActive,
  closeSubModalState,
  handleLinkAccount,
  subModalHtml,
  modalMainCustomClass,
  hideTopSection
}) => {
  const showHideClassName = show ? 'modal displayBlock' : 'modal displayNone';
  return (
    <div
      className={` ${showHideClassName} ${modalCustomClass}`}
      onClick={handleClose}
    >
      {subModalActive && (
        <div
          className="modalOverlay"
          onClick={event => event.stopPropagation()}
        ></div>
      )}
      <section
        className={`modalMain ${
          subModalActive ? 'subActive' : ''
        } ${modalMainCustomClass}`}
        onClick={event => event.stopPropagation()}
      >
        {/* back to last modal */}
        {backBtn && (
          <p className="appendBottom20">
            <a
              className="modalBack capText font12 latoBlack"
              onClick={handleBack}
            >
              {' '}
              Back{' '}
            </a>
          </p>
        )}
        {closeBtn && (
          <p className="modalClose appendBottom20 textRight">
            <span
              className="crossIcon popupSprite popupCrossIcon"
              onClick={handleClose}
            ></span>
          </p>
        )}
        {/* super elemnts before title */}
        {modalSuper && <div className="appendBottom25">{modalSuper}</div>}
        {!hideTopSection && (
          <div className="appendBottom25">
            {modalTitle && (
              <p className="modalTitle makeFlex hrtlCenter font26 latoBlack appendBottom5">
                {modalTitle}
              </p>
            )}
            {modalSubTitle && (
              <p className="font14 darkGreyText makeFlex">{modalSubTitle}</p>
            )}
            {serverError && (
              <p className="font12 redText appendTop5 makeFlex serverError">
                <span className="appendRight5 popupSprite errorCross"></span>
                <span>{serverError}</span>
              </p>
            )}
          </div>
        )}
        {children}
        {skipBtn && (
          <p className="font16 textCenter lightGreyText latoBold capText">
            {' '}
            Skip{' '}
          </p>
        )}
      </section>
      {<div>{subModalHtml}</div>}
    </div>
  );
};
